import { types } from 'mobx-state-tree';
export const PropertyInformationInitialData = {
  propertyAddress: '',
  ownership: '',
  buildingSquare: ''
};
export const PropertyInformation = types.model({
  propertyAddress: types.maybeNull(types.string),
  ownership: types.maybeNull(types.string),
  buildingSquare: types.maybeNull(types.union(types.string, types.number))
});